import React from 'react';
import { OverallDisplayMode } from 'libs/end-to-end/src/view-configurations';
import { NumericDisplayUnit } from 'libs/end-to-end/src/metrics';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { ViewConfigurationSchema } from 'libs/end-to-end/src/view-configurations';
import { determineUnitOfMetric } from 'libs/end-to-end/src/metrics';

export const computeValue = ({
  value,
  numeratorSize,
  chartUnits,
  overallDisplayMode,
}: {
  value: number;
  numeratorSize: number;
  chartUnits: NumericDisplayUnit;
  overallDisplayMode: OverallDisplayMode | undefined;
}) => {
  const displayOverallCount = overallDisplayMode === 'count';

  if (displayOverallCount) {
    return numeratorSize;
  }

  if (chartUnits === 'percentage') {
    return value * 100;
  }

  return value;
};

export const computeUnits = ({
  metricInfo,
  viewConfiguration,
}: {
  metricInfo: {
    focusArea: FocusArea;
    metric: MyMetricDefinition;
  };
  viewConfiguration: ViewConfigurationSchema;
}) => {
  return (
    viewConfiguration.units ??
    determineUnitOfMetric({
      knownMaximum: null,
      isMetricBoolean: metricInfo.metric.isMetricBoolean,
      metricFocusArea: metricInfo.focusArea,
      definitionUnit: metricInfo.metric.unit,
    })
  );
};
